import React, { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { URLAPI } from "../../../Helpers/apimaderas";

const KIUFLOW_HTTP_BASE = "https://apiengine.kiuflow.online/api/v1/http";

const INITIAL_FORM_DATA = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

const TOAST_OPTIONS = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export default function ContactForm({
  tokenAsesor,
  pathname,
  kiuflowContactChannel,
  kiuflowAgentId,
}) {
  const { t } = useTranslation();
  const [dataForm, setDataForm] = useState(INITIAL_FORM_DATA);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChangeForm = (event) => {
    const { name, value } = event.target;
    setDataForm((previousData) => ({
      ...previousData,
      [name]: value,
    }));
  };

  const readKiuflowResponse = async (response) => {
    const responseData = await response.json().catch(() => null);

    if (!response.ok || responseData?.success !== true) {
      throw new Error(responseData?.message || t("app.errorEnvioContacto"));
    }

    return responseData;
  };

  const sendToKiuflow = async () => {
    const channelCode = encodeURIComponent(kiuflowContactChannel);
    const agentId = String(kiuflowAgentId || "").trim();

    if (!agentId) {
      throw new Error(t("app.canalContactoNoDisponible"));
    }

    const registerResponse = await fetch(
      `${KIUFLOW_HTTP_BASE}/${channelCode}/register`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: dataForm.name.trim(),
          phone: dataForm.phone.trim(),
          email: dataForm.email.trim(),
          agentId,
        }),
      }
    );
    const registeredClient = await readKiuflowResponse(registerResponse);
    const webId = registeredClient?.data?.webId;

    if (!webId) {
      throw new Error(t("app.errorEnvioContacto"));
    }

    const messageResponse = await fetch(
      `${KIUFLOW_HTTP_BASE}/${channelCode}/client/${encodeURIComponent(webId)}/process`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: dataForm.message.trim(),
        }),
      }
    );

    await readKiuflowResponse(messageResponse);
  };

  const sendToCurrentApi = async () => {
    const response = await fetch(`${URLAPI(pathname)}/contact/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: tokenAsesor,
        nombre: dataForm.name.trim(),
        telefono: dataForm.phone.trim(),
        email: dataForm.email.trim(),
        mensaje: dataForm.message.trim(),
      }),
    });
    const responseData = await response.json().catch(() => null);

    if (
      !response.ok ||
      (responseData?.success !== true && responseData?.message !== "Success")
    ) {
      throw new Error(responseData?.message || t("app.errorEnvioContacto"));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      if (kiuflowContactChannel) {
        await sendToKiuflow();
      } else if (pathname?.includes("segura")) {
        await sendToCurrentApi();
      } else {
        throw new Error(t("app.canalContactoNoDisponible"));
      }

      toast.success(t("app.contactoEnviado"), TOAST_OPTIONS);
      setDataForm(INITIAL_FORM_DATA);
    } catch (error) {
      toast.error(error.message || t("app.errorEnvioContacto"), TOAST_OPTIONS);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      className="contact-form"
      onSubmit={handleSubmit}
      aria-busy={isSubmitting}
    >
      <div className="form-input-item mb-60">
        <label className="input-lebel name" htmlFor="contact-name">
          {t("app.nombreContacto")} *
        </label>
        <input
          id="contact-name"
          name="name"
          className="input-box name height"
          type="text"
          required
          autoComplete="name"
          onChange={handleChangeForm}
          value={dataForm.name}
        />
      </div>
      <div className="form-input-item mb-60">
        <label className="input-lebel gmail" htmlFor="contact-email">
          {t("app.correoContacto")} *
        </label>
        <input
          id="contact-email"
          name="email"
          className="input-box gmail height"
          type="email"
          required
          autoComplete="email"
          onChange={handleChangeForm}
          value={dataForm.email}
        />
      </div>
      <div className="form-input-item mb-60">
        <label className="input-lebel gmail" htmlFor="contact-phone">
          {t("app.telefonoContacto")} *
        </label>
        <input
          id="contact-phone"
          name="phone"
          className="input-box gmail height"
          type="tel"
          required
          autoComplete="tel"
          onChange={handleChangeForm}
          value={dataForm.phone}
        />
      </div>
      <div className="form-input-item mb-40">
        <label className="input-lebel message" htmlFor="contact-message">
          {t("app.mensajeContacto")} *
        </label>
        <textarea
          id="contact-message"
          maxLength={150}
          name="message"
          className="input-box message height"
          onChange={handleChangeForm}
          value={dataForm.message}
          cols="30"
          rows="10"
          required
        ></textarea>
      </div>
      <div className="form-btn-wrap">
        <button type="submit" className="form-btn" disabled={isSubmitting}>
          {isSubmitting ? t("app.enviando") : t("app.enviar")}
        </button>
      </div>
    </form>
  );
}
